/**
 * Normalizes raw seat collections from RTDB/state (arrays or keyed objects) into a 4-element array.
 */
export function extractNormalizedSeatsList(rawSeats: any): any[] {
  if (Array.isArray(rawSeats)) return rawSeats;
  if (rawSeats && typeof rawSeats === 'object') {
    return [
      rawSeats[0] ?? rawSeats['0'],
      rawSeats[1] ?? rawSeats['1'],
      rawSeats[2] ?? rawSeats['2'],
      rawSeats[3] ?? rawSeats['3'],
    ];
  }
  return [];
}
